import { useEffect, useState } from 'react';

import { Box, Typography } from '@mui/material';

import axiosApiInstance from '@/api/shared/axios-instance';
import URL_FACTORY from '@/helpers/url-helper';
import NoticiasPostContentRow from '@/components/creador-de-contenido/NoticiasPostContentRow';

const RecentNews = ({ slug }) => {
    const [articles, setArticles] = useState([]);

    useEffect(() => {
        const url = URL_FACTORY.URL_GET_RECENT_ARTICLES;

        axiosApiInstance
            .post(url, {
                skip: 0,
                take: 15,
                ignore: slug,
            })
            .then((response) => {
                setArticles(response.data?.articles);
            });
    }, []);

    return (
        <Box id="recent-news">
            <Typography
                sx={{
                    fontSize: '18px',
                    marginBottom: '8px',
                }}
                variant="h2"
            >
                Noticias Recientes
            </Typography>
            {articles?.map((post, index) => {
                return (
                    <Box key={index}>
                        <NoticiasPostContentRow
                            cover={post.image ?? post.cover}
                            title={post.title}
                            slug={post.slug}
                            url={post.url}
                        />
                    </Box>
                );
            })}
        </Box>
    );
};

export default RecentNews;
